import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class Loader extends Component {
  render() {
    const { small, logo, dark } = this.props;

    let loadClass = 'vlt-load';

    if (small) {
      loadClass = 'vlt-load sml';
      return (
        <div className={loadClass}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    }

    if (logo) {
      loadClass = 'vlt-load-logo';
      if (dark) {
        loadClass = 'vlt-load-logo vll-dark';
      }
      return (
        <div className={loadClass}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    }

    return (
      <div className={loadClass}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  }
}

export default withRouter(Loader);
